import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from "react-router-dom";

import { Button, Modal, Table, Spinner  } from "react-bootstrap";
import {} from 'react-bootstrap-icons';

import AlertErrorComponent from './AlertErrorComponent';

import moment from 'moment';
import 'moment-timezone';

// Services
import {
    getPOLogs
} from '../services/PurchaseOrder';

import {LOGGING_LABELS} from '../constants/GlobalConstant';

import I18N from "../js/i18n";

const services = {
    getPOLogs
};

const axios = require('axios').default;

class LogsModalComponent extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isLoading:true,
            logsData:[]
        }
    }

    componentDidMount = () => {
        this.getPOLogs();
    }

    componentDidUpdate = () => {
    }

/*
APIs
*/

/*
(GET) PO Logs
*/

    getPOLogs = async () => {
        let poId = this.props.poId;
        if(typeof this.props.poId === "object") {
            poId = this.props.poId[0];
        }

        try {
            const props = {
                token:this.props.auth.token,
                logType:'po',
                poId:poId
            }
            const response = await getPOLogs(props);
            if(response.data.auditTrail) {
                this.setState({
                    logsData:response.data.auditTrail,
                    isLoading:false
                });
            } else {
                this.setState({
                    logsData:[]
                }); 
            }
        } catch (err) {
            this.handleErrorAPI(err);
        }
    }

    handleErrorAPI = (err) => {
        this.setState({
            isLoading:false
        }, () => {
            if(err)
            console.log(err);
        });
    }

/*
Modal
*/

    getLoggingAction = (action) => {
        let filter = LOGGING_LABELS.action.filter( (obj) => obj.id === action)[0];
        if(filter) {
            return filter.label;
        }
        return;
    }

    render() {
        return (
            <Modal 
                show={true}
                size="lg"
                onHide={ () => {
                    this.props.handleClickLogs();
                }}
            >    
                <Modal.Header closeButton>
                    <Modal.Title><I18N type="ui" path="PURCHASE_ORDER_LOGS" def="Purchase Order Logs"/></Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    {this.state.isLoading
                        ?
                            <div className="text-center">
                                <Spinner 
                                    animation="border" 
                                    role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </Spinner>
                            </div>
                        :
                            <div className="overflow-scroll">
                            <Table responsive bordered hover={this.state.logsData.length > 0 ? true : false}>
                                <thead>
                                    <tr>
                                        <th><I18N type="ui" path="AUDIT_DATE" def="Audit Date"/></th>
                                        <th><I18N type="ui" path="PLATFORM" def="Platform"/></th>
                                        <th><I18N type="ui" path="OPERATOR" def="Operator"/></th>
                                        <th><I18N type="ui" path="ACTION" def="Action"/></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {   
                                    this.state.logsData.length > 0
                                    ?
                                        this.state.logsData.map( (log) => {
                                            return (
                                                <tr>
                                                    <td>{moment(log.AuditDate).utc(0).format('D MMM YYYY, h:mm:ss a')}</td>
                                                    <td>{log.Platform === 1 ? "Console" : "Horus App"}</td>
                                                    <td>{log.Operator}</td>
                                                    <td>{this.getLoggingAction(log.Action)}</td>
                                                </tr>
                                            );
                                        })
                                    :
                                        <tr>
                                            <td colSpan="4">
                                            <AlertErrorComponent 
                                                label={<I18N type="ui" path="NO_LOGS_FOUND" def="No logs found"/>}
                                            />
                                            </td>
                                        </tr>
                                    }
                                </tbody>
                            </Table>
                            </div>
                    }
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => this.props.handleClickLogs()}>
                        <I18N type="ui" path="CLOSE" def="Close"/>
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }

}

const mapStateToProps = state => {
    const {auth} = state;
    return { auth: auth };
};

export default connect(mapStateToProps, null)(withRouter(LogsModalComponent));